import { useMemo, useState } from 'react';
import {
    Checkbox,
    ListItemText,
    Menu,
    useTheme,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import Button from '@/components/ui/Button/Button';
import MenuItem from '@/components/ui/MenuItem/MenuItem';
import type { FilterDropdownProps } from './IFilterDropdown';
import { styles } from './styles';

const FilterDropdown = ({
    title,
    options,
    icon: Icon,
    onChange,
}: FilterDropdownProps) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const selectedCount = useMemo(
        () => options.filter((o) => o.selected).length,
        [options],
    );

    const toggleOption = (value: string) => {
        const next = options
            .map((opt) =>
                opt.value === value ? { ...opt, selected: !opt.selected } : opt,
            )
            .filter((opt) => opt.selected)
            .map((opt) => opt.value);
        onChange(next);
    };

    return (
        <>
            <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={styles.button(theme)}
                endIcon={<ArrowDropDown />}
            >
                {Icon && <Icon sx={{ width: 16, height: 16 }} />}
                {title}
                {selectedCount > 0 && ` (${selectedCount})`}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 1,
                            maxHeight: 280,
                            minWidth: 220,
                        },
                    },
                }}
            >
                {options.length === 0 && (
                    <MenuItem disabled>No options</MenuItem>
                )}
                {options.map((opt) => (
                    <MenuItem
                        key={opt.value}
                        onClick={() => toggleOption(opt.value)}
                        sx={styles.menuItem}
                    >
                        <Checkbox checked={opt.selected} size="small" />
                        <ListItemText primary={opt.name} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default FilterDropdown;
